import { DataAttributeDefinitions } from 'scrivito'

import { pisaAddressDataClass } from './Pisa/pisaAddressDataClass'

const attributes: DataAttributeDefinitions = {}

export const Address = pisaAddressDataClass(attributes)
